export enum DeviceStatus {
  PENDING_SECOND_FACTOR = 1,
  OK = 2,
  PENDING_MANUAL_APPROVAL = 3,
  NOT_APPROVED = 4,
  BLOCKED = 5,
}

export enum TokenMethod {
  SMS = 'sms',
  WHATSAPP = 'wpp',
}
